import React from "react";
import { Box, Typography } from "@mui/material";
import FilterPanelItem from "./FilterPanelItem";
import styles from "./FilterPanel.module.css";
import { Filter } from "../../../context/ConfigContext/types";

import { useConfig } from "../../../context/ConfigContext";
import GenericInputField from "../../GenericInputField";

export enum SearchQueryProp {
	TITLE = "title",
	INCLUDE_TEXT = "includeText",
	EXCLUDE_TEXT = "excludeText",
}
export interface FilterPanelProps {
	filters: Filter[];
}

const FilterPanel: React.FunctionComponent<FilterPanelProps> = ({
	filters,
}) => {
	const { searchQuery, setSearchQuery } = useConfig();

	const handleInputChange = (value: string, property: SearchQueryProp) => {
		setSearchQuery((prevQuery) => {
			return {
				...prevQuery,
				[property]: value,
			};
		});
	};

	const handleUnselectDocument = (
		documentId: number,
		propertyName: "includeDocuments" | "excludeDocuments",
	) => {
		setSearchQuery((query) => {
			const updatedArray = query[propertyName].filter(
				(d) => d.id !== documentId,
			);
			return { ...query, [propertyName]: updatedArray };
		});
	};

	return (
		<Box className={styles.filterPanelContainer}>
			<Box className={styles.group}>
				<Typography variant="h5" className={styles.title}>
					Filters
				</Typography>
				{filters?.map((filter) => (
					<Box key={filter.filterName} className={styles.row}>
						<FilterPanelItem filter={filter} />
					</Box>
				))}
			</Box>

			{
				// TODO: bring back when vector db is fixed
				/* <Box className={styles.group}>
				<Typography variant="h5" className={styles.title}>
					Query Settings
				</Typography>
				<Box className={styles.row}>
					<FilterPanelItem
						title="Include"
						onUnselectDocumentClick={(id) =>
							handleUnselectDocument(id, "includeDocuments")
						}
						documents={searchQuery.includeDocuments}
					>
						<Box sx={{ background: "white" }}>
							<GenericInputField
								currentValue={searchQuery.includeText}
								placeholder=""
								multiline
								onValueChange={(value) =>
									handleInputChange(value, SearchQueryProp.INCLUDE_TEXT)
								}
							/>
						</Box>
					</FilterPanelItem>
				</Box>
				<Box className={styles.row}>
					<FilterPanelItem
						title="Exclude"
						onUnselectDocumentClick={(id) =>
							handleUnselectDocument(id, "excludeDocuments")
						}
						documents={searchQuery.excludeDocuments}
					>
						<Box sx={{ background: "white" }}>
							<GenericInputField
								currentValue={searchQuery.excludeText}
								placeholder=""
								multiline
								onValueChange={(value) =>
									handleInputChange(value, SearchQueryProp.EXCLUDE_TEXT)
								}
							/>
						</Box>
					</FilterPanelItem>
				</Box>
			</Box> */
			}
		</Box>
	);
};

export default FilterPanel;
